// extracted by mini-css-extract-plugin
module.exports = {"icon":"style__icon__ud2N+"};